export default "__VITE_ASSET__CPl$ZqD$__"